import assertNever from "../../../global/assetNever";
import {ObjectModelRelationType} from "../../enums/objectModelRelationType";
import {EnumHelper} from "../../helpers/enumHelper";
import ObjectModelRelation from "./objectModelRelation";
import {ObjectModelRelationCapability} from "./objectModelRelationCapability";
import {ModelType} from '~/enums/modelType'

export default class ObjectModelRelationCapabilityManager {
  static debug: boolean = false;

  static LABELABLE_CONTROLS: ObjectModelRelationType[] = [
    ObjectModelRelationType.OneToOne,
    ObjectModelRelationType.OneToMany,
    ObjectModelRelationType.ManyToOne,
    ObjectModelRelationType.Account,
    ObjectModelRelationType.EntityAccount,
  ];

  static INVERSE_LABELABLE_CONTROLS: ObjectModelRelationType[] = [
    ObjectModelRelationType.OneToOne,
    ObjectModelRelationType.OneToMany,
    ObjectModelRelationType.ManyToOne,
  ];

  static REQUIREABLE_CONTROLS: ObjectModelRelationType[] = [
    ObjectModelRelationType.OneToOne,
    ObjectModelRelationType.OneToMany,
    ObjectModelRelationType.ManyToOne,
  ];

  static INVERSE_DEPENDENT_DESTROY_CONTROLS: ObjectModelRelationType[] = [
    ObjectModelRelationType.OneToOne,
    ObjectModelRelationType.OneToMany,
    ObjectModelRelationType.ManyToOne,
  ];

  static RESTRICTABLE_CONTROLS: ObjectModelRelationType[] = [
    ObjectModelRelationType.Account,
  ]

  static REFERENCEABLE_CONTROLS: ObjectModelRelationType[] = [
    ObjectModelRelationType.OneToOne,
    ObjectModelRelationType.OneToMany,
    ObjectModelRelationType.ManyToOne,
    ObjectModelRelationType.Account,
    ObjectModelRelationType.EntityAccount,
  ]

  static INDEXABLE_CONTROLS: ObjectModelRelationType[] = [
    ObjectModelRelationType.OneToOne,
    ObjectModelRelationType.OneToMany,
    ObjectModelRelationType.ManyToOne,
    ObjectModelRelationType.Account,
  ];

  static PORTAL_CLAIMABLE_CONTROLS: ObjectModelRelationType[] = [
    ObjectModelRelationType.EntityAccount,
  ]

  static can(type: ObjectModelRelationType, duty: ObjectModelRelationCapability) {
    let can: boolean = false;
    switch (duty) {
      case ObjectModelRelationCapability.labelable:
        can = ObjectModelRelationCapabilityManager.LABELABLE_CONTROLS.includes(type);
        break;
      case ObjectModelRelationCapability.inverseLabelable:
        can = ObjectModelRelationCapabilityManager.INVERSE_LABELABLE_CONTROLS.includes(type);
        break;
      case ObjectModelRelationCapability.requireable:
        can = ObjectModelRelationCapabilityManager.REQUIREABLE_CONTROLS.includes(type);
        break;
      case ObjectModelRelationCapability.inverseDependentDestroy:
        can = ObjectModelRelationCapabilityManager.INVERSE_DEPENDENT_DESTROY_CONTROLS.includes(type);
        break;
      case ObjectModelRelationCapability.accountRelationUserTypeable:
        can = ObjectModelRelationCapabilityManager.RESTRICTABLE_CONTROLS.includes(type);
        break;
      case ObjectModelRelationCapability.referenceable:
        can = ObjectModelRelationCapabilityManager.REFERENCEABLE_CONTROLS.includes(type);
        break;
      case ObjectModelRelationCapability.indexable:
        can = ObjectModelRelationCapabilityManager.INDEXABLE_CONTROLS.includes(type);
        break;
      case ObjectModelRelationCapability.portalClaimable:
        can = ObjectModelRelationCapabilityManager.PORTAL_CLAIMABLE_CONTROLS.includes(type);
        break;
      default:
        assertNever(duty);
        can = false;
        break;
    }
    ObjectModelRelationCapabilityManager.log(`Type ${ObjectModelRelationType[type]} ${can ? 'can' : 'can\'t'} ${ObjectModelRelationCapability[duty]}`);
    return can;
  }

  static addDefaultProperties(f: ObjectModelRelation) {
    f.defineProperty('related_object_model_ids', []);

    // done this way so a case statement can use assertNever to ensure all capabilities are accounted for
    EnumHelper.toArray(ObjectModelRelationCapability).forEach((c: ObjectModelRelationCapability) => {
      switch (c) {
        case ObjectModelRelationCapability.labelable:
          f.defineProperty('label_title', null);
          break;
        case ObjectModelRelationCapability.inverseLabelable:
          f.defineProperty('inverse_label_title', null);
          break;
        case ObjectModelRelationCapability.requireable:
          f.defineProperty('is_required', false);
          break;
        case ObjectModelRelationCapability.inverseDependentDestroy:
          f.defineProperty('inverse_dependent_destroy', false);
          break;
        case ObjectModelRelationCapability.accountRelationUserTypeable:
          f.defineProperty('user_type', ModelType.PortalUser);
          break;
        case ObjectModelRelationCapability.referenceable:
          f.defineProperty('reference_name', null);
          break;
        case ObjectModelRelationCapability.indexable:
          break;
        case ObjectModelRelationCapability.portalClaimable:
          f.defineProperty('portal_for_claiming', 'onestop');
          break;
        default:
          assertNever(c);
          break;
      }
    });
  }

  private static log(message: string) {
    if (this.debug) {
      console.log(`DEBUG: ObjectModelRelationCan: ${message}`);
    }
  }
}